import "./ReadingModal.css";
import { getBookRegisteredDate } from "../utils/format";

/**
 * 지금 읽는 중인 책.
 *
 * 예전에는 '읽는 중' 칩이 목록 탭을 바꿨다. 그런데 탭이
 * 전체·완독·읽고 싶은 책 셋으로 정리되면서 읽는 중에 해당하는 탭이
 * 없어졌고, 칩을 눌러도 탭 줄에는 아무것도 켜지지 않았다.
 * 목록을 바꾸는 대신 따로 띄운다.
 *
 * 여기서만 보여줄 수 있는 값이 하나 있다 — 며칠째 읽고 있는지.
 * 책 화면에 들어가 시작일을 보고 오늘과 견주지 않으면 알 수 없던 값이다.
 */

/** 시작일부터 오늘까지 며칠. 한국 기준으로 자른다. */
const daysSince = (display) => {
  if (!display) return null;
  const [y, m, d] = display.split(".").map(Number);
  if (!y || !m || !d) return null;
  const start = new Date(y, m - 1, d);
  const todayStr = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
  const [ty, tm, td] = todayStr.split("-").map(Number);
  const today = new Date(ty, tm - 1, td);
  const diff = Math.floor((today - start) / 86400000);
  return diff < 0 ? null : diff;
};

const ReadingModal = ({ books, uid, onClose, onBookClick }) => {
  /* 오래 붙들고 있는 책이 위로 온다. 잊고 있던 책이 이 목록의 요점이다. */
  const items = [...(books || [])]
    .map((book) => ({ book, days: daysSince(getBookRegisteredDate(book, uid)) }))
    .sort((a, b) => (b.days ?? -1) - (a.days ?? -1));

  return (
    <div className="rd-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="rd-modal" role="dialog" aria-label="읽는 중">
        <div className="rd-head">
          <div>
            <div className="rd-title">읽는 중</div>
            <div className="rd-sub">담았지만 아직 끝내지 않은 책</div>
          </div>
          <button className="rd-close" onClick={onClose} aria-label="닫기">✕</button>
        </div>

        {items.length === 0 ? (
          <div className="rd-empty">지금 읽는 중인 책이 없어요.</div>
        ) : (
          <ul className="rd-list">
            {items.map(({ book, days }, i) => (
              <li
                key={book.id}
                className="rd-item"
                style={{ animationDelay: `${i * 0.05}s` }}
                onClick={() => { onClose(); if (onBookClick) onBookClick(book.id); }}
              >
                <div className="rd-cover">
                  {book.cover ? <img src={book.cover} alt="" /> : <span>📖</span>}
                </div>
                <div className="rd-info">
                  <div className="rd-book-title">{book.title}</div>
                  <div className="rd-book-author">{book.author}</div>
                </div>
                {/* 시작일이 없거나 미래면 날짜 계산을 보여주지 않는다.
                    '-3일째' 같은 값이 나오면 안 된다. */}
                {days !== null && (
                  <div className="rd-days">
                    <span className="rd-days-num">{days === 0 ? "오늘" : days}</span>
                    {days !== 0 && <span className="rd-days-label">일째</span>}
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ReadingModal;
